<div class="progressbar-wrapper">
  <ngb-progressbar
    [type]="currentStatus?.type"
    [value]="currentStatus?.percent"
    [striped]="true"
    [animated]="true"
  ></ngb-progressbar>
    <span>{{ currentStatus?.title | translate }}</span>
</div>
